import { render, staticRenderFns } from "./FilterStatusFollowUp.vue?vue&type=template&id=38d02246&scoped=true"
import script from "./FilterStatusFollowUp.vue?vue&type=script&lang=js"
export * from "./FilterStatusFollowUp.vue?vue&type=script&lang=js"
import style0 from "./FilterStatusFollowUp.vue?vue&type=style&index=0&id=38d02246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d02246",
  null
  
)

export default component.exports